import React from "react";
import Button from "./Button";

export default function ContactUsForm({ ...props }) {
  return (
    <section className="container mx-auto" {...props}>
      <div className="shadow rounded-lg p-10 pb-14 md:my-32 my-16 md:mx-32 lg:mx-64 mx-6 bg-white">
        <div className="pb-7">
          <div className="text-3xl font-bold text-left py-2">
            <span>
              Kuhaku is archived, and new work is <b className="text-primary">closed</b>
            </span>
          </div>
          <p className="text-base leading-7 text-gray-600 max-w-2xl mt-4">
            The company is no longer active, but this site stays up as a
            celebration of what the team built together. If you came here looking
            for a live studio, this is now a historical snapshot.
          </p>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <Button text="View the work" size="lg" href="#works" />
          <Button text="Meet the team" size="lg" href="#team" />
        </div>
      </div>
    </section>
  );
}
